/**
 * Central app config. No secrets — anything sensitive lives in Cloud Functions
 * params, never in the client bundle.
 */
export const APP_URL =
  import.meta.env.VITE_APP_URL || 'https://reshima.io';

// Our own backend: Python service on the Elestio VM behind the Cloudflare tunnel.
export const API_BASE =
  import.meta.env.VITE_API_BASE || 'https://reshima-api.octomonic.com';

// Public join link a player opens (or receives over WhatsApp).
export const joinUrl = (joinCode) => `${APP_URL}/j/${joinCode}`;

export const CURRENCY = '₪';
